// Please don't change values of constants since they are used in database

export const CUSTOMER_PROCESS_INSTANCE_LIST = 'ProcessInstanceList'

export const CUSTOMER_SALES_ORDER_LIST = 'SalesOrderList'

export const CUSTOMER_XRAY_FILE_UPLOAD = 'XRayFileUploadContainer'

export const CUSTOMER_COMMENT_LIST = 'ProcessCommentList'

export const CUSTOMER_ADD_COMMENT = 'NewProcessComment'



// WEBPACK FOOTER //
// ./src/modules/customer/ui-definition/customer-ui.js